<template>
  <div>
    <v-form
      ref="form"
      v-model="valid"
      :lazy-validation="lazy"
      @keyup.native.enter="!$v.$invalid && saveFolder($event)"
    >
      <v-container>
        <v-row>
          <v-col xs="12" md="12">
            <v-card outlined>
              <v-card-text class="text--primary">
                <v-row no-gutters>
                  <v-col cols="12">
                    <notification-container
                      :showOnlyLocalNotifications="true"
                    ></notification-container>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="8">
                    <v-text-field
                      id="folder_form__nombre__text"
                      name="folder_form__nombre__text"
                      v-model="folderForm.nombre"
                      autofocus
                      :counter="50"
                      :error-messages="
                        getErrors('folderForm.nombre', 'El nombre')
                      "
                      label="Nombre"
                      required
                      @input="$v.folderForm.nombre.$touch()"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      id="folder_form__descripcion__text"
                      name="folder_form__descripcion__text"
                      v-model="folderForm.descripcion"
                      :counter="100"
                      :error-messages="
                        getErrors('folderForm.descripcion', 'La descripción')
                      "
                      label="Descripción"
                      @input="$v.folderForm.descripcion.$touch()"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="text-right">
                  <v-col cols="12">
                    <v-btn
                      :id="
                        isNewFolder
                          ? 'folder_form__guardar__button'
                          : 'folder_form__actualizar__button'
                      "
                      :name="
                        isNewFolder
                          ? 'folder_form__guardar__button'
                          : 'folder_form__actualizar__button'
                      "
                      color="secondary"
                      @click.prevent="saveFolder"
                      :loading="loading"
                      >{{ isNewFolder ? 'Guardar' : 'Actualizar' }}</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import { pushNotification, messageErrorResponse } from '@/store/helpers'
import { required, maxLength } from 'vuelidate/lib/validators'
import VuelidateHelper from '@/utils/VuelidateHelper'
import {
  notSpecialCharsPunctuation,
  notSpecialCharsDescription
} from '@/utils/VuelidateCustoms'
import Folder from '@/models/Folder'

import {
  folderStoreData,
  folderStoreActions
} from '../store/folderStoreHelpers'

export default {
  name: 'FolderForm',
  props: {
    folder: {
      type: Object,
      default: null
    },
    parent: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    valid: true,
    loading: false,
    lazy: false,
    vuelidateHelper: null,
    folderForm: new Folder()
  }),
  created() {
    this.vuelidateHelper = new VuelidateHelper(this.$v)
    if (this.folder != null) {
      this.folderForm = Object.assign(new Folder(), this.folder)
    }
  },
  watch: {
    folder: function(val) {
      this.folderForm = Object.assign(new Folder(), val)
    }
  },
  validations: {
    folderForm: {
      nombre: {
        required,
        maxLength: maxLength(50),
        notSpecialCharsPunctuation
      },
      descripcion: {
        maxLength: maxLength(100),
        notSpecialCharsDescription
      }
    }
  },
  computed: {
    ...folderStoreData,
    isNewFolder() {
      return this.folder == null
    }
  },
  methods: {
    ...folderStoreActions,
    saveFolder() {
      this.$v.$touch()
      if (this.$v.$anyError) {
        return
      }
      this.loading = true

      let data = {
        nombre: this.folderForm.nombre,
        descripcion: this.folderForm.descripcion
      }

      let operation
      let codeService
      if (this.isNewFolder) {
        data.idCarpetaPadre = this.parent.idCarpeta
        operation = this.createFolder(data)
        codeService = this.codeFolderServicePost200
      } else {
        data.idCarpeta = this.folderForm.idCarpeta
        operation = this.updateFolder(data)
        codeService = this.codeFolderServicePut200
      }

      operation
        .then(result => {
          if (result.data.successful.code == codeService) {
            this.resetForm()
            this.$emit('onSuccessActionFolder')
            //this.pushFoldersOpen(this.folderSelected.idCarpeta)
          } else {
            this.notificationError(result)
          }
        })
        .catch(err => {
          this.notificationError(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getErrors(campo, label = '') {
      return this.vuelidateHelper.getErrors(campo, label)
    },
    resetForm() {
      this.$refs.form.reset()
      this.$v.$reset()
    },
    notificationError(msg) {
      pushNotification(
        this.$store,
        messageErrorResponse(msg) || this.msgFolderServiceError,
        'error',
        'left',
        false,
        true
      )
    }
  }
}
</script>
